import { useState } from "react";
import { Button } from "@/modern/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/modern/components/ui/dialog";
import { ScrollArea } from "@/modern/components/ui/scroll-area";
import { DateHelper } from "@bryntum/schedulerpro";
import { Card } from "@/modern/components/ui/card";
import { Badge } from "@/modern/components/ui/badge";
import { pluralize } from "@/other/utils/otherUtils.jsx";

const ExecutedIncentivesListModal = ({
  incentiveRecords = [],
  taskIds = [],
  onShowPointsClicked,
  onDismiss,
  onClose,
}) => {
  const [isDisplay, setIsDisplay] = useState(incentiveRecords.length > 0);

  const onCloseModal = () => {
    setIsDisplay(false);
    onClose();
  };

  const onShowPoints = async () => {
    try {
      const executedIncentiveRecordIds = incentiveRecords.map((item) => item.id);

      if (executedIncentiveRecordIds.length > 0) {
        onShowPointsClicked(executedIncentiveRecordIds);
      }

      if (taskIds.length > 0) {
        await onDismiss(taskIds);
      }

      onCloseModal();
    } catch (error) {
      console.error("Error processing incentive evaluation tasks:", error);
    }
  };

  if (!isDisplay) {
    return null;
  }

  return (
    <Dialog
      open={isDisplay}
      onOpenChange={(open) => {
        if (!open) onCloseModal();
      }}
    >
      <DialogContent
        className="z-[calc(var(--swivu-bryntum-z-index)+10)] sm:max-w-[600px]"
        dialogOverlayClassName="z-[calc(var(--swivu-bryntum-z-index)+10)]"
      >
        <DialogHeader>
          <DialogTitle>Executed {pluralize(incentiveRecords.length, "Point", "s")}</DialogTitle>
          <DialogDescription>
            {incentiveRecords.length > 1
              ? "Below is a list of all executed points records pending your review."
              : "Below is the executed points record pending your review."}
          </DialogDescription>
        </DialogHeader>

        <ScrollArea className="max-h-[400px] w-full">
          <div className="space-y-swivu-base p-swivu-base">
            {incentiveRecords.map((record) => (
              <Card
                key={record.id}
                variant="modern"
                size="base"
                className="flex items-center justify-between"
              >
                <div className="flex-1">
                  <h4 className="text-swivu-md mb-1 font-medium">{record.name}</h4>
                  <p className="text-swivu-sm text-muted-foreground m-0">
                    Created On: {DateHelper.format(new Date(record.createdAt), "MM/DD/YYYY")}
                  </p>
                </div>
                <Badge variant="primary-gradient" size="sm">
                  Points {record.points}
                </Badge>
              </Card>
            ))}
          </div>
        </ScrollArea>

        <DialogFooter>
          <Button onClick={onShowPoints}>Show Points</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExecutedIncentivesListModal;
